import { render, staticRenderFns } from "./TeacherPlanner.vue?vue&type=template&id=556580cf"
import script from "./TeacherPlanner.vue?vue&type=script&lang=js"
export * from "./TeacherPlanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports